import React, { useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import AntLocalization from '../../utils/AntLocalization';
import AntCommentThread from '../AntCommentThread';
import './index.scss';

// ═══════════════════════════════════════════════════════════════════
// ─── FLOATING COMMENT PANEL ─────────────────────────────────────
// ═══════════════════════════════════════════════════════════════════

function FloatingCommentPanel(props) {
    var visible = props.visible;
    var onClose = props.onClose;
    var context = props.context;
    var title = props.title;

    var handleBackdropClick = useCallback(function (e) {
        if (e.target === e.currentTarget && onClose) onClose();
    }, [onClose]);

    // Esc closes, like other popups.
    useEffect(function () {
        if (!visible) return undefined;
        var onKey = function (e) { if (e.key === 'Escape' && onClose) onClose(); };
        document.addEventListener('keydown', onKey);
        return function () { document.removeEventListener('keydown', onKey); };
    }, [visible, onClose]);

    if (!visible) return null;

    var defaultTitle = AntLocalization.translateText({ vi: 'Bình luận', en: 'Comments', fr: 'Commentaires', es: 'Comentarios', id: 'Komentar', ja: 'コメント', zh: '评论', ko: '댓글', hi: 'टिप्पणियाँ', ar: 'التعليقات' });
    var panelTitle = title || defaultTitle;
    if (context && context.voucherTypeLabel) {
        panelTitle = (title || defaultTitle) + ' — ' + context.voucherTypeLabel;
    }

    var content = (
        <div className="floating-comment-overlay" onClick={handleBackdropClick}>
            <div className="floating-comment-panel">
                {/* Header */}
                <div className="fc-header">
                    <div className="fc-header-title">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                        </svg>
                        <span>{panelTitle}</span>
                        {context && context.voucherCode && (
                            <span className="fc-header-code">{context.voucherCode}</span>
                        )}
                    </div>
                    <button className="fc-close-btn" onClick={onClose} title={AntLocalization.translateText({ vi: 'Đóng', en: 'Close', fr: 'Fermer', es: 'Cerrar', id: 'Tutup', ja: '閉じる', zh: '关闭', ko: '닫기', hi: 'बंद करें', ar: 'إغلاق' })}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Comment body: shared thread */}
                <div className="fc-thread">
                    <AntCommentThread context={context} autoFocus={visible} />
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(content, document.body);
}

export default FloatingCommentPanel;
